import React, { useState, useEffect } from 'react';
import StaticSidebar from './StaticSidebar';
import TopBar from './TopBar';
import TimezoneNotificationBar from '../common/TimezoneNotificationBar';

export default function DashboardLayout({ children }) {
  // Initialize sidebar state - open on desktop, closed on mobile
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = sessionStorage.getItem('sidebarOpen');
    if (saved !== null) {
      return JSON.parse(saved);
    }
    // Default: open on desktop (lg screens), closed on mobile
    return window.innerWidth >= 1024;
  });

  // Persist sidebar state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  // Handle window resize - close sidebar on mobile when resizing
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setSidebarOpen((open) => !open);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <StaticSidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {/* Main Content */}
      <div className={`transition-all duration-300 ease-in-out ${sidebarOpen ? 'lg:pl-72' : ''}`}>
        <TopBar toggleSidebar={toggleSidebar} />
        <TimezoneNotificationBar />
        <main className="p-1 md:p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
} 